import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { MdOutlineCancel } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { links } from '../data/dummy';
import { useStateContext } from '../contexts/ContextProvider';
import logo from '../images/logo-trans.png';
import { BsChevronDown } from 'react-icons/bs';

const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white  text-md m-2';
const normalLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2 cursor-pointer';

const NavItem = (props) => {
  const [ showSubMenu, setShowSubMenu ] = useState(false);
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();
  let { link } = props;
  
  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const RenderLink = (link) => (
    link.type === 'link' ? <NavLink
      to={`/${link.link}`}
      key={link.name}
      onClick={handleCloseSideBar}
      style={({ isActive }) => ({
        backgroundColor: isActive ? currentColor : '',
      })}
      className={({ isActive }) => (isActive ? activeLink : normalLink)}
    >
      <div className="w-full flex items-center space-between gap-4">
        {link.icon}
        <span className="capitalize text-[14px]">{link.name.split('-').join(' ')}</span>
      </div>
      {link.subLinks?.length > 0 && <BsChevronDown className="mr-6" />}
    </NavLink> :
      <div
        key={link.name}
        onClick={() => setShowSubMenu(!showSubMenu)}
        className={`${normalLink}`}
      >
        <div className="w-full flex items-center space-between gap-4">
          {link.icon}
          <span className="capitalize">{link.name.split('-').join(' ')}</span>
        </div>
        {link.subLinks?.length > 0 && <BsChevronDown className="mr-6" />}
      </div>
  );

  return (
    <div {...props} className="link-con">
      {RenderLink(link)}
      {link.subLinks?.length > 0 && showSubMenu && <div className="bg-gray-200 pl-4 rounded-l-lg overflow-y-hidden">
        {link.subLinks.map(link => RenderLink(link))}
      </div>}
    </div>
  )
}

const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  return (
    <div className="ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
          <div className="flex justify-between items-center">
            <Link to="/" onClick={handleCloseSideBar} className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-slate-900">
              {/* <SiShopware /> <span>Shoppy</span> */}
              <img
                className="w-30 h-20"
                src={logo}
                alt="user-profile"
              />
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="mt-5">
            {links.map((item) => (
              <div key={item.title}>
                <p className="text-gray-400 dark:text-gray-400 m-3 text-[13px] mt-4 capitalize">
                  {item.title}
                </p>
                {item.links.map((link, index) => (
                  <NavItem key={index} link={link} />
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
